module.exports = __webpack_public_path__ + "img/polaris_bank.bed8cdb2.svg";